module.exports = __webpack_public_path__ + "img/activities.b9dafde4.svg";